// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_org.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  StcsCompRoleEnum,
  stcsCompRoleEnumFromJSON,
  stcsCompRoleEnumToJSON,
  StcsEntityStatusEnum,
  stcsEntityStatusEnumFromJSON,
  stcsEntityStatusEnumToJSON,
  StcsOrgRoleEnum,
  stcsOrgRoleEnumFromJSON,
  stcsOrgRoleEnumToJSON,
  StcsSubProductCycleEnum,
  stcsSubProductCycleEnumFromJSON,
  stcsSubProductCycleEnumToJSON,
} from "./stcs_enums.entity";
import { StcsUserData } from "./stcs_user.entity";

export const protobufPackage = "stcs_cmw";

export interface StcsOrgList {
  entries: StcsOrg[];
}

export interface StcsOrg {
  id: string;
  version: string;
  meta: StcsOrgMeta | undefined;
  data: StcsOrgData | undefined;
  status: StcsEntityStatusEnum;
  subscription?:
    | StcsOrgSubscription
    | undefined;
  /** use StripeEvent::CheckoutSession for all invoice details */
  invoice_details?:
    | StcsOrgInvoiceDetails
    | undefined;
  /** use Stripe::Subscription for all Org, comp and user seats details, including trial date end */
  onboarding?: StcsOrgOnboarding | undefined;
  sandbox: boolean;
}

export interface StcsOrgMeta {
  obj_created_iso_utc: string;
  obj_updated_iso_utc: string;
  ref_id_user: string;
  ref_comp_map: { [key: string]: StcsOrgCompMap };
  org_role_map: { [key: string]: StcsOrgRoleEnum };
}

export interface StcsOrgMeta_RefCompMapEntry {
  key: string;
  value: StcsOrgCompMap | undefined;
}

export interface StcsOrgMeta_OrgRoleMapEntry {
  key: string;
  value: StcsOrgRoleEnum;
}

export interface StcsOrgOnboarding {
  has_started: boolean;
  is_paused: boolean;
  is_completed: boolean;
  obj_created_iso_utc: string;
  obj_updated_iso_utc: string;
  ref_id_comp_sandbox: string;
  ref_id_comp_onboarding: string;
  ref_id_org_sandbox: string;
  ref_id_user: string;
  steps_map: { [key: string]: StcsOrgOnboarding_StcsOrgOnboardingStep };
}

export interface StcsOrgOnboarding_StepsMapEntry {
  key: string;
  value: StcsOrgOnboarding_StcsOrgOnboardingStep | undefined;
}

export interface StcsOrgOnboarding_StcsOrgOnboardingStep {
  done: boolean;
  ref_id_user: string;
  obj_created_iso_utc: string;
  /** Deprecated */
  can_navigate_to: boolean;
  url: string;
}

/** v1.0.1 */
export interface StcsOrgCompMap {
  sort_index: number;
  ref_user_map: { [key: string]: StcsOrgCompUserMap };
}

export interface StcsOrgCompMap_RefUserMapEntry {
  key: string;
  value: StcsOrgCompUserMap | undefined;
}

export interface StcsOrgCompUserMap {
  role: StcsCompRoleEnum;
}

export interface StcsOrgInvoiceAddress {
  city: string;
  company_name: string;
  country: string;
  line1: string;
  line2: string;
  postal_code: string;
  tax_id: string;
}

export interface StcsOrgInvoiceDetails {
  invoice_address: StcsOrgInvoiceAddress | undefined;
  invoice_email: string;
}

export interface StcsOrgData {
  fpna_fye_month: number;
  cfg_logo_url: string;
  fpna_country: string;
  fpna_currency: string;
  fpna_industry: number;
  display_name: string;
  ref_id_org_fsd_struct: string;
  ref_id_org_fsd_flat: string;
  referral_source_text: string;
}

export interface StcsOrgUsage {
  user_seats_licensed: number;
  user_seats_active: number;
  company_seats_licensed: number;
  company_seats_active: number;
}

export interface StcsOrgSubscription {
  valid_until_iso_utc: string;
  customer_external_id: string;
  subscription_external_id: string;
  usage: StcsOrgUsage | undefined;
  subscription_status: StcsEntityStatusEnum;
  ref_id_product_org_seats: string;
  ref_id_product_user_seats: string;
  ref_id_product_company_seats: string;
  subscription_cycle: StcsSubProductCycleEnum;
}

export interface StcsOrgUserList {
  org_user_data_map: { [key: string]: StcsUserData };
}

export interface StcsOrgUserList_OrgUserDataMapEntry {
  key: string;
  value: StcsUserData | undefined;
}

function createBaseStcsOrgList(): StcsOrgList {
  return { entries: [] };
}

export const StcsOrgList: MessageFns<StcsOrgList> = {
  encode(message: StcsOrgList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entries) {
      StcsOrg.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entries.push(StcsOrg.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgList {
    return {
      entries: globalThis.Array.isArray(object?.entries) ? object.entries.map((e: any) => StcsOrg.fromJSON(e)) : [],
    };
  },

  toJSON(message: StcsOrgList): unknown {
    const obj: any = {};
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => StcsOrg.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgList>, I>>(base?: I): StcsOrgList {
    return StcsOrgList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgList>, I>>(object: I): StcsOrgList {
    const message = createBaseStcsOrgList();
    message.entries = object.entries?.map((e) => StcsOrg.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStcsOrg(): StcsOrg {
  return {
    id: "",
    version: "",
    meta: undefined,
    data: undefined,
    status: 0,
    subscription: undefined,
    invoice_details: undefined,
    onboarding: undefined,
    sandbox: false,
  };
}

export const StcsOrg: MessageFns<StcsOrg> = {
  encode(message: StcsOrg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsOrgMeta.encode(message.meta, writer.uint32(26).fork()).join();
    }
    if (message.data !== undefined) {
      StcsOrgData.encode(message.data, writer.uint32(34).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(80).int32(message.status);
    }
    if (message.subscription !== undefined) {
      StcsOrgSubscription.encode(message.subscription, writer.uint32(42).fork()).join();
    }
    if (message.invoice_details !== undefined) {
      StcsOrgInvoiceDetails.encode(message.invoice_details, writer.uint32(58).fork()).join();
    }
    if (message.onboarding !== undefined) {
      StcsOrgOnboarding.encode(message.onboarding, writer.uint32(66).fork()).join();
    }
    if (message.sandbox !== false) {
      writer.uint32(72).bool(message.sandbox);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = StcsOrgMeta.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.data = StcsOrgData.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.subscription = StcsOrgSubscription.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.invoice_details = StcsOrgInvoiceDetails.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.onboarding = StcsOrgOnboarding.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.sandbox = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrg {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsOrgMeta.fromJSON(object.meta) : undefined,
      data: isSet(object.data) ? StcsOrgData.fromJSON(object.data) : undefined,
      status: isSet(object.status) ? stcsEntityStatusEnumFromJSON(object.status) : 0,
      subscription: isSet(object.subscription) ? StcsOrgSubscription.fromJSON(object.subscription) : undefined,
      invoice_details: isSet(object.invoice_details)
        ? StcsOrgInvoiceDetails.fromJSON(object.invoice_details)
        : undefined,
      onboarding: isSet(object.onboarding) ? StcsOrgOnboarding.fromJSON(object.onboarding) : undefined,
      sandbox: isSet(object.sandbox) ? globalThis.Boolean(object.sandbox) : false,
    };
  },

  toJSON(message: StcsOrg): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsOrgMeta.toJSON(message.meta);
    }
    if (message.data !== undefined) {
      obj.data = StcsOrgData.toJSON(message.data);
    }
    if (message.status !== 0) {
      obj.status = stcsEntityStatusEnumToJSON(message.status);
    }
    if (message.subscription !== undefined) {
      obj.subscription = StcsOrgSubscription.toJSON(message.subscription);
    }
    if (message.invoice_details !== undefined) {
      obj.invoice_details = StcsOrgInvoiceDetails.toJSON(message.invoice_details);
    }
    if (message.onboarding !== undefined) {
      obj.onboarding = StcsOrgOnboarding.toJSON(message.onboarding);
    }
    if (message.sandbox !== false) {
      obj.sandbox = message.sandbox;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrg>, I>>(base?: I): StcsOrg {
    return StcsOrg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrg>, I>>(object: I): StcsOrg {
    const message = createBaseStcsOrg();
    message.id = object.id ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsOrgMeta.fromPartial(object.meta)
      : undefined;
    message.data = (object.data !== undefined && object.data !== null)
      ? StcsOrgData.fromPartial(object.data)
      : undefined;
    message.status = object.status ?? 0;
    message.subscription = (object.subscription !== undefined && object.subscription !== null)
      ? StcsOrgSubscription.fromPartial(object.subscription)
      : undefined;
    message.invoice_details = (object.invoice_details !== undefined && object.invoice_details !== null)
      ? StcsOrgInvoiceDetails.fromPartial(object.invoice_details)
      : undefined;
    message.onboarding = (object.onboarding !== undefined && object.onboarding !== null)
      ? StcsOrgOnboarding.fromPartial(object.onboarding)
      : undefined;
    message.sandbox = object.sandbox ?? false;
    return message;
  },
};

function createBaseStcsOrgMeta(): StcsOrgMeta {
  return { obj_created_iso_utc: "", obj_updated_iso_utc: "", ref_id_user: "", ref_comp_map: {}, org_role_map: {} };
}

export const StcsOrgMeta: MessageFns<StcsOrgMeta> = {
  encode(message: StcsOrgMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(10).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(18).string(message.obj_updated_iso_utc);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(26).string(message.ref_id_user);
    }
    Object.entries(message.ref_comp_map).forEach(([key, value]) => {
      StcsOrgMeta_RefCompMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    Object.entries(message.org_role_map).forEach(([key, value]) => {
      StcsOrgMeta_OrgRoleMapEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = StcsOrgMeta_RefCompMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.ref_comp_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = StcsOrgMeta_OrgRoleMapEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.org_role_map[entry5.key] = entry5.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgMeta {
    return {
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_comp_map: isObject(object.ref_comp_map)
        ? Object.entries(object.ref_comp_map).reduce<{ [key: string]: StcsOrgCompMap }>((acc, [key, value]) => {
          acc[key] = StcsOrgCompMap.fromJSON(value);
          return acc;
        }, {})
        : {},
      org_role_map: isObject(object.org_role_map)
        ? Object.entries(object.org_role_map).reduce<{ [key: string]: StcsOrgRoleEnum }>((acc, [key, value]) => {
          acc[key] = stcsOrgRoleEnumFromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsOrgMeta): unknown {
    const obj: any = {};
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_comp_map) {
      const entries = Object.entries(message.ref_comp_map);
      if (entries.length > 0) {
        obj.ref_comp_map = {};
        entries.forEach(([k, v]) => {
          obj.ref_comp_map[k] = StcsOrgCompMap.toJSON(v);
        });
      }
    }
    if (message.org_role_map) {
      const entries = Object.entries(message.org_role_map);
      if (entries.length > 0) {
        obj.org_role_map = {};
        entries.forEach(([k, v]) => {
          obj.org_role_map[k] = stcsOrgRoleEnumToJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgMeta>, I>>(base?: I): StcsOrgMeta {
    return StcsOrgMeta.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgMeta>, I>>(object: I): StcsOrgMeta {
    const message = createBaseStcsOrgMeta();
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_comp_map = Object.entries(object.ref_comp_map ?? {}).reduce<{ [key: string]: StcsOrgCompMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsOrgCompMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.org_role_map = Object.entries(object.org_role_map ?? {}).reduce<{ [key: string]: StcsOrgRoleEnum }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = value as StcsOrgRoleEnum;
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsOrgMeta_RefCompMapEntry(): StcsOrgMeta_RefCompMapEntry {
  return { key: "", value: undefined };
}

export const StcsOrgMeta_RefCompMapEntry: MessageFns<StcsOrgMeta_RefCompMapEntry> = {
  encode(message: StcsOrgMeta_RefCompMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsOrgCompMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgMeta_RefCompMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgMeta_RefCompMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsOrgCompMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgMeta_RefCompMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsOrgCompMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsOrgMeta_RefCompMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsOrgCompMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgMeta_RefCompMapEntry>, I>>(base?: I): StcsOrgMeta_RefCompMapEntry {
    return StcsOrgMeta_RefCompMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgMeta_RefCompMapEntry>, I>>(object: I): StcsOrgMeta_RefCompMapEntry {
    const message = createBaseStcsOrgMeta_RefCompMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsOrgCompMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsOrgMeta_OrgRoleMapEntry(): StcsOrgMeta_OrgRoleMapEntry {
  return { key: "", value: 0 };
}

export const StcsOrgMeta_OrgRoleMapEntry: MessageFns<StcsOrgMeta_OrgRoleMapEntry> = {
  encode(message: StcsOrgMeta_OrgRoleMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(16).int32(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgMeta_OrgRoleMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgMeta_OrgRoleMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgMeta_OrgRoleMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? stcsOrgRoleEnumFromJSON(object.value) : 0,
    };
  },

  toJSON(message: StcsOrgMeta_OrgRoleMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = stcsOrgRoleEnumToJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgMeta_OrgRoleMapEntry>, I>>(base?: I): StcsOrgMeta_OrgRoleMapEntry {
    return StcsOrgMeta_OrgRoleMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgMeta_OrgRoleMapEntry>, I>>(object: I): StcsOrgMeta_OrgRoleMapEntry {
    const message = createBaseStcsOrgMeta_OrgRoleMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseStcsOrgOnboarding(): StcsOrgOnboarding {
  return {
    has_started: false,
    is_paused: false,
    is_completed: false,
    obj_created_iso_utc: "",
    obj_updated_iso_utc: "",
    ref_id_comp_sandbox: "",
    ref_id_comp_onboarding: "",
    ref_id_org_sandbox: "",
    ref_id_user: "",
    steps_map: {},
  };
}

export const StcsOrgOnboarding: MessageFns<StcsOrgOnboarding> = {
  encode(message: StcsOrgOnboarding, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.has_started !== false) {
      writer.uint32(8).bool(message.has_started);
    }
    if (message.is_paused !== false) {
      writer.uint32(16).bool(message.is_paused);
    }
    if (message.is_completed !== false) {
      writer.uint32(24).bool(message.is_completed);
    }
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(34).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(42).string(message.obj_updated_iso_utc);
    }
    if (message.ref_id_comp_sandbox !== "") {
      writer.uint32(50).string(message.ref_id_comp_sandbox);
    }
    if (message.ref_id_comp_onboarding !== "") {
      writer.uint32(58).string(message.ref_id_comp_onboarding);
    }
    if (message.ref_id_org_sandbox !== "") {
      writer.uint32(66).string(message.ref_id_org_sandbox);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(74).string(message.ref_id_user);
    }
    Object.entries(message.steps_map).forEach(([key, value]) => {
      StcsOrgOnboarding_StepsMapEntry.encode({ key: key as any, value }, writer.uint32(82).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgOnboarding {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgOnboarding();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.has_started = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.is_paused = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.is_completed = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ref_id_comp_sandbox = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ref_id_comp_onboarding = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.ref_id_org_sandbox = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          const entry10 = StcsOrgOnboarding_StepsMapEntry.decode(reader, reader.uint32());
          if (entry10.value !== undefined) {
            message.steps_map[entry10.key] = entry10.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgOnboarding {
    return {
      has_started: isSet(object.has_started) ? globalThis.Boolean(object.has_started) : false,
      is_paused: isSet(object.is_paused) ? globalThis.Boolean(object.is_paused) : false,
      is_completed: isSet(object.is_completed) ? globalThis.Boolean(object.is_completed) : false,
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
      ref_id_comp_sandbox: isSet(object.ref_id_comp_sandbox) ? globalThis.String(object.ref_id_comp_sandbox) : "",
      ref_id_comp_onboarding: isSet(object.ref_id_comp_onboarding)
        ? globalThis.String(object.ref_id_comp_onboarding)
        : "",
      ref_id_org_sandbox: isSet(object.ref_id_org_sandbox) ? globalThis.String(object.ref_id_org_sandbox) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      steps_map: isObject(object.steps_map)
        ? Object.entries(object.steps_map).reduce<{ [key: string]: StcsOrgOnboarding_StcsOrgOnboardingStep }>(
          (acc, [key, value]) => {
            acc[key] = StcsOrgOnboarding_StcsOrgOnboardingStep.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: StcsOrgOnboarding): unknown {
    const obj: any = {};
    if (message.has_started !== false) {
      obj.has_started = message.has_started;
    }
    if (message.is_paused !== false) {
      obj.is_paused = message.is_paused;
    }
    if (message.is_completed !== false) {
      obj.is_completed = message.is_completed;
    }
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    if (message.ref_id_comp_sandbox !== "") {
      obj.ref_id_comp_sandbox = message.ref_id_comp_sandbox;
    }
    if (message.ref_id_comp_onboarding !== "") {
      obj.ref_id_comp_onboarding = message.ref_id_comp_onboarding;
    }
    if (message.ref_id_org_sandbox !== "") {
      obj.ref_id_org_sandbox = message.ref_id_org_sandbox;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.steps_map) {
      const entries = Object.entries(message.steps_map);
      if (entries.length > 0) {
        obj.steps_map = {};
        entries.forEach(([k, v]) => {
          obj.steps_map[k] = StcsOrgOnboarding_StcsOrgOnboardingStep.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgOnboarding>, I>>(base?: I): StcsOrgOnboarding {
    return StcsOrgOnboarding.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgOnboarding>, I>>(object: I): StcsOrgOnboarding {
    const message = createBaseStcsOrgOnboarding();
    message.has_started = object.has_started ?? false;
    message.is_paused = object.is_paused ?? false;
    message.is_completed = object.is_completed ?? false;
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    message.ref_id_comp_sandbox = object.ref_id_comp_sandbox ?? "";
    message.ref_id_comp_onboarding = object.ref_id_comp_onboarding ?? "";
    message.ref_id_org_sandbox = object.ref_id_org_sandbox ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    message.steps_map = Object.entries(object.steps_map ?? {}).reduce<
      { [key: string]: StcsOrgOnboarding_StcsOrgOnboardingStep }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = StcsOrgOnboarding_StcsOrgOnboardingStep.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseStcsOrgOnboarding_StepsMapEntry(): StcsOrgOnboarding_StepsMapEntry {
  return { key: "", value: undefined };
}

export const StcsOrgOnboarding_StepsMapEntry: MessageFns<StcsOrgOnboarding_StepsMapEntry> = {
  encode(message: StcsOrgOnboarding_StepsMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsOrgOnboarding_StcsOrgOnboardingStep.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgOnboarding_StepsMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgOnboarding_StepsMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsOrgOnboarding_StcsOrgOnboardingStep.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgOnboarding_StepsMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsOrgOnboarding_StcsOrgOnboardingStep.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsOrgOnboarding_StepsMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsOrgOnboarding_StcsOrgOnboardingStep.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgOnboarding_StepsMapEntry>, I>>(base?: I): StcsOrgOnboarding_StepsMapEntry {
    return StcsOrgOnboarding_StepsMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgOnboarding_StepsMapEntry>, I>>(
    object: I,
  ): StcsOrgOnboarding_StepsMapEntry {
    const message = createBaseStcsOrgOnboarding_StepsMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsOrgOnboarding_StcsOrgOnboardingStep.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsOrgOnboarding_StcsOrgOnboardingStep(): StcsOrgOnboarding_StcsOrgOnboardingStep {
  return { done: false, ref_id_user: "", obj_created_iso_utc: "", can_navigate_to: false, url: "" };
}

export const StcsOrgOnboarding_StcsOrgOnboardingStep: MessageFns<StcsOrgOnboarding_StcsOrgOnboardingStep> = {
  encode(message: StcsOrgOnboarding_StcsOrgOnboardingStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.done !== false) {
      writer.uint32(8).bool(message.done);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(18).string(message.ref_id_user);
    }
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(26).string(message.obj_created_iso_utc);
    }
    if (message.can_navigate_to !== false) {
      writer.uint32(32).bool(message.can_navigate_to);
    }
    if (message.url !== "") {
      writer.uint32(42).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgOnboarding_StcsOrgOnboardingStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgOnboarding_StcsOrgOnboardingStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.done = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.can_navigate_to = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgOnboarding_StcsOrgOnboardingStep {
    return {
      done: isSet(object.done) ? globalThis.Boolean(object.done) : false,
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      can_navigate_to: isSet(object.can_navigate_to) ? globalThis.Boolean(object.can_navigate_to) : false,
      url: isSet(object.url) ? globalThis.String(object.url) : "",
    };
  },

  toJSON(message: StcsOrgOnboarding_StcsOrgOnboardingStep): unknown {
    const obj: any = {};
    if (message.done !== false) {
      obj.done = message.done;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.can_navigate_to !== false) {
      obj.can_navigate_to = message.can_navigate_to;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgOnboarding_StcsOrgOnboardingStep>, I>>(
    base?: I,
  ): StcsOrgOnboarding_StcsOrgOnboardingStep {
    return StcsOrgOnboarding_StcsOrgOnboardingStep.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgOnboarding_StcsOrgOnboardingStep>, I>>(
    object: I,
  ): StcsOrgOnboarding_StcsOrgOnboardingStep {
    const message = createBaseStcsOrgOnboarding_StcsOrgOnboardingStep();
    message.done = object.done ?? false;
    message.ref_id_user = object.ref_id_user ?? "";
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.can_navigate_to = object.can_navigate_to ?? false;
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseStcsOrgCompMap(): StcsOrgCompMap {
  return { sort_index: 0, ref_user_map: {} };
}

export const StcsOrgCompMap: MessageFns<StcsOrgCompMap> = {
  encode(message: StcsOrgCompMap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sort_index !== 0) {
      writer.uint32(8).uint32(message.sort_index);
    }
    Object.entries(message.ref_user_map).forEach(([key, value]) => {
      StcsOrgCompMap_RefUserMapEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgCompMap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgCompMap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sort_index = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = StcsOrgCompMap_RefUserMapEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.ref_user_map[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgCompMap {
    return {
      sort_index: isSet(object.sort_index) ? globalThis.Number(object.sort_index) : 0,
      ref_user_map: isObject(object.ref_user_map)
        ? Object.entries(object.ref_user_map).reduce<{ [key: string]: StcsOrgCompUserMap }>((acc, [key, value]) => {
          acc[key] = StcsOrgCompUserMap.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsOrgCompMap): unknown {
    const obj: any = {};
    if (message.sort_index !== 0) {
      obj.sort_index = Math.round(message.sort_index);
    }
    if (message.ref_user_map) {
      const entries = Object.entries(message.ref_user_map);
      if (entries.length > 0) {
        obj.ref_user_map = {};
        entries.forEach(([k, v]) => {
          obj.ref_user_map[k] = StcsOrgCompUserMap.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgCompMap>, I>>(base?: I): StcsOrgCompMap {
    return StcsOrgCompMap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgCompMap>, I>>(object: I): StcsOrgCompMap {
    const message = createBaseStcsOrgCompMap();
    message.sort_index = object.sort_index ?? 0;
    message.ref_user_map = Object.entries(object.ref_user_map ?? {}).reduce<{ [key: string]: StcsOrgCompUserMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsOrgCompUserMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsOrgCompMap_RefUserMapEntry(): StcsOrgCompMap_RefUserMapEntry {
  return { key: "", value: undefined };
}

export const StcsOrgCompMap_RefUserMapEntry: MessageFns<StcsOrgCompMap_RefUserMapEntry> = {
  encode(message: StcsOrgCompMap_RefUserMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsOrgCompUserMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgCompMap_RefUserMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgCompMap_RefUserMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsOrgCompUserMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgCompMap_RefUserMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsOrgCompUserMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsOrgCompMap_RefUserMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsOrgCompUserMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgCompMap_RefUserMapEntry>, I>>(base?: I): StcsOrgCompMap_RefUserMapEntry {
    return StcsOrgCompMap_RefUserMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgCompMap_RefUserMapEntry>, I>>(
    object: I,
  ): StcsOrgCompMap_RefUserMapEntry {
    const message = createBaseStcsOrgCompMap_RefUserMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsOrgCompUserMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsOrgCompUserMap(): StcsOrgCompUserMap {
  return { role: 0 };
}

export const StcsOrgCompUserMap: MessageFns<StcsOrgCompUserMap> = {
  encode(message: StcsOrgCompUserMap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.role !== 0) {
      writer.uint32(8).int32(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgCompUserMap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgCompUserMap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgCompUserMap {
    return { role: isSet(object.role) ? stcsCompRoleEnumFromJSON(object.role) : 0 };
  },

  toJSON(message: StcsOrgCompUserMap): unknown {
    const obj: any = {};
    if (message.role !== 0) {
      obj.role = stcsCompRoleEnumToJSON(message.role);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgCompUserMap>, I>>(base?: I): StcsOrgCompUserMap {
    return StcsOrgCompUserMap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgCompUserMap>, I>>(object: I): StcsOrgCompUserMap {
    const message = createBaseStcsOrgCompUserMap();
    message.role = object.role ?? 0;
    return message;
  },
};

function createBaseStcsOrgInvoiceAddress(): StcsOrgInvoiceAddress {
  return { city: "", company_name: "", country: "", line1: "", line2: "", postal_code: "", tax_id: "" };
}

export const StcsOrgInvoiceAddress: MessageFns<StcsOrgInvoiceAddress> = {
  encode(message: StcsOrgInvoiceAddress, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.city !== "") {
      writer.uint32(10).string(message.city);
    }
    if (message.company_name !== "") {
      writer.uint32(18).string(message.company_name);
    }
    if (message.country !== "") {
      writer.uint32(26).string(message.country);
    }
    if (message.line1 !== "") {
      writer.uint32(34).string(message.line1);
    }
    if (message.line2 !== "") {
      writer.uint32(42).string(message.line2);
    }
    if (message.postal_code !== "") {
      writer.uint32(50).string(message.postal_code);
    }
    if (message.tax_id !== "") {
      writer.uint32(58).string(message.tax_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgInvoiceAddress {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgInvoiceAddress();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.city = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.company_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.country = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.line1 = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.line2 = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.postal_code = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tax_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgInvoiceAddress {
    return {
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      company_name: isSet(object.company_name) ? globalThis.String(object.company_name) : "",
      country: isSet(object.country) ? globalThis.String(object.country) : "",
      line1: isSet(object.line1) ? globalThis.String(object.line1) : "",
      line2: isSet(object.line2) ? globalThis.String(object.line2) : "",
      postal_code: isSet(object.postal_code) ? globalThis.String(object.postal_code) : "",
      tax_id: isSet(object.tax_id) ? globalThis.String(object.tax_id) : "",
    };
  },

  toJSON(message: StcsOrgInvoiceAddress): unknown {
    const obj: any = {};
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.company_name !== "") {
      obj.company_name = message.company_name;
    }
    if (message.country !== "") {
      obj.country = message.country;
    }
    if (message.line1 !== "") {
      obj.line1 = message.line1;
    }
    if (message.line2 !== "") {
      obj.line2 = message.line2;
    }
    if (message.postal_code !== "") {
      obj.postal_code = message.postal_code;
    }
    if (message.tax_id !== "") {
      obj.tax_id = message.tax_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgInvoiceAddress>, I>>(base?: I): StcsOrgInvoiceAddress {
    return StcsOrgInvoiceAddress.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgInvoiceAddress>, I>>(object: I): StcsOrgInvoiceAddress {
    const message = createBaseStcsOrgInvoiceAddress();
    message.city = object.city ?? "";
    message.company_name = object.company_name ?? "";
    message.country = object.country ?? "";
    message.line1 = object.line1 ?? "";
    message.line2 = object.line2 ?? "";
    message.postal_code = object.postal_code ?? "";
    message.tax_id = object.tax_id ?? "";
    return message;
  },
};

function createBaseStcsOrgInvoiceDetails(): StcsOrgInvoiceDetails {
  return { invoice_address: undefined, invoice_email: "" };
}

export const StcsOrgInvoiceDetails: MessageFns<StcsOrgInvoiceDetails> = {
  encode(message: StcsOrgInvoiceDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.invoice_address !== undefined) {
      StcsOrgInvoiceAddress.encode(message.invoice_address, writer.uint32(10).fork()).join();
    }
    if (message.invoice_email !== "") {
      writer.uint32(18).string(message.invoice_email);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgInvoiceDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgInvoiceDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.invoice_address = StcsOrgInvoiceAddress.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.invoice_email = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgInvoiceDetails {
    return {
      invoice_address: isSet(object.invoice_address)
        ? StcsOrgInvoiceAddress.fromJSON(object.invoice_address)
        : undefined,
      invoice_email: isSet(object.invoice_email) ? globalThis.String(object.invoice_email) : "",
    };
  },

  toJSON(message: StcsOrgInvoiceDetails): unknown {
    const obj: any = {};
    if (message.invoice_address !== undefined) {
      obj.invoice_address = StcsOrgInvoiceAddress.toJSON(message.invoice_address);
    }
    if (message.invoice_email !== "") {
      obj.invoice_email = message.invoice_email;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgInvoiceDetails>, I>>(base?: I): StcsOrgInvoiceDetails {
    return StcsOrgInvoiceDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgInvoiceDetails>, I>>(object: I): StcsOrgInvoiceDetails {
    const message = createBaseStcsOrgInvoiceDetails();
    message.invoice_address = (object.invoice_address !== undefined && object.invoice_address !== null)
      ? StcsOrgInvoiceAddress.fromPartial(object.invoice_address)
      : undefined;
    message.invoice_email = object.invoice_email ?? "";
    return message;
  },
};

function createBaseStcsOrgData(): StcsOrgData {
  return {
    fpna_fye_month: 0,
    cfg_logo_url: "",
    fpna_country: "",
    fpna_currency: "",
    fpna_industry: 0,
    display_name: "",
    ref_id_org_fsd_struct: "",
    ref_id_org_fsd_flat: "",
    referral_source_text: "",
  };
}

export const StcsOrgData: MessageFns<StcsOrgData> = {
  encode(message: StcsOrgData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fpna_fye_month !== 0) {
      writer.uint32(16).uint32(message.fpna_fye_month);
    }
    if (message.cfg_logo_url !== "") {
      writer.uint32(34).string(message.cfg_logo_url);
    }
    if (message.fpna_country !== "") {
      writer.uint32(42).string(message.fpna_country);
    }
    if (message.fpna_currency !== "") {
      writer.uint32(50).string(message.fpna_currency);
    }
    if (message.fpna_industry !== 0) {
      writer.uint32(56).uint32(message.fpna_industry);
    }
    if (message.display_name !== "") {
      writer.uint32(74).string(message.display_name);
    }
    if (message.ref_id_org_fsd_struct !== "") {
      writer.uint32(82).string(message.ref_id_org_fsd_struct);
    }
    if (message.ref_id_org_fsd_flat !== "") {
      writer.uint32(90).string(message.ref_id_org_fsd_flat);
    }
    if (message.referral_source_text !== "") {
      writer.uint32(98).string(message.referral_source_text);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.fpna_fye_month = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.cfg_logo_url = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fpna_country = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fpna_currency = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.fpna_industry = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.display_name = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.ref_id_org_fsd_struct = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.ref_id_org_fsd_flat = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.referral_source_text = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgData {
    return {
      fpna_fye_month: isSet(object.fpna_fye_month) ? globalThis.Number(object.fpna_fye_month) : 0,
      cfg_logo_url: isSet(object.cfg_logo_url) ? globalThis.String(object.cfg_logo_url) : "",
      fpna_country: isSet(object.fpna_country) ? globalThis.String(object.fpna_country) : "",
      fpna_currency: isSet(object.fpna_currency) ? globalThis.String(object.fpna_currency) : "",
      fpna_industry: isSet(object.fpna_industry) ? globalThis.Number(object.fpna_industry) : 0,
      display_name: isSet(object.display_name) ? globalThis.String(object.display_name) : "",
      ref_id_org_fsd_struct: isSet(object.ref_id_org_fsd_struct) ? globalThis.String(object.ref_id_org_fsd_struct) : "",
      ref_id_org_fsd_flat: isSet(object.ref_id_org_fsd_flat) ? globalThis.String(object.ref_id_org_fsd_flat) : "",
      referral_source_text: isSet(object.referral_source_text) ? globalThis.String(object.referral_source_text) : "",
    };
  },

  toJSON(message: StcsOrgData): unknown {
    const obj: any = {};
    if (message.fpna_fye_month !== 0) {
      obj.fpna_fye_month = Math.round(message.fpna_fye_month);
    }
    if (message.cfg_logo_url !== "") {
      obj.cfg_logo_url = message.cfg_logo_url;
    }
    if (message.fpna_country !== "") {
      obj.fpna_country = message.fpna_country;
    }
    if (message.fpna_currency !== "") {
      obj.fpna_currency = message.fpna_currency;
    }
    if (message.fpna_industry !== 0) {
      obj.fpna_industry = Math.round(message.fpna_industry);
    }
    if (message.display_name !== "") {
      obj.display_name = message.display_name;
    }
    if (message.ref_id_org_fsd_struct !== "") {
      obj.ref_id_org_fsd_struct = message.ref_id_org_fsd_struct;
    }
    if (message.ref_id_org_fsd_flat !== "") {
      obj.ref_id_org_fsd_flat = message.ref_id_org_fsd_flat;
    }
    if (message.referral_source_text !== "") {
      obj.referral_source_text = message.referral_source_text;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgData>, I>>(base?: I): StcsOrgData {
    return StcsOrgData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgData>, I>>(object: I): StcsOrgData {
    const message = createBaseStcsOrgData();
    message.fpna_fye_month = object.fpna_fye_month ?? 0;
    message.cfg_logo_url = object.cfg_logo_url ?? "";
    message.fpna_country = object.fpna_country ?? "";
    message.fpna_currency = object.fpna_currency ?? "";
    message.fpna_industry = object.fpna_industry ?? 0;
    message.display_name = object.display_name ?? "";
    message.ref_id_org_fsd_struct = object.ref_id_org_fsd_struct ?? "";
    message.ref_id_org_fsd_flat = object.ref_id_org_fsd_flat ?? "";
    message.referral_source_text = object.referral_source_text ?? "";
    return message;
  },
};

function createBaseStcsOrgUsage(): StcsOrgUsage {
  return { user_seats_licensed: 0, user_seats_active: 0, company_seats_licensed: 0, company_seats_active: 0 };
}

export const StcsOrgUsage: MessageFns<StcsOrgUsage> = {
  encode(message: StcsOrgUsage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.user_seats_licensed !== 0) {
      writer.uint32(8).uint32(message.user_seats_licensed);
    }
    if (message.user_seats_active !== 0) {
      writer.uint32(16).uint32(message.user_seats_active);
    }
    if (message.company_seats_licensed !== 0) {
      writer.uint32(24).uint32(message.company_seats_licensed);
    }
    if (message.company_seats_active !== 0) {
      writer.uint32(32).uint32(message.company_seats_active);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgUsage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgUsage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.user_seats_licensed = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.user_seats_active = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.company_seats_licensed = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.company_seats_active = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgUsage {
    return {
      user_seats_licensed: isSet(object.user_seats_licensed) ? globalThis.Number(object.user_seats_licensed) : 0,
      user_seats_active: isSet(object.user_seats_active) ? globalThis.Number(object.user_seats_active) : 0,
      company_seats_licensed: isSet(object.company_seats_licensed)
        ? globalThis.Number(object.company_seats_licensed)
        : 0,
      company_seats_active: isSet(object.company_seats_active) ? globalThis.Number(object.company_seats_active) : 0,
    };
  },

  toJSON(message: StcsOrgUsage): unknown {
    const obj: any = {};
    if (message.user_seats_licensed !== 0) {
      obj.user_seats_licensed = Math.round(message.user_seats_licensed);
    }
    if (message.user_seats_active !== 0) {
      obj.user_seats_active = Math.round(message.user_seats_active);
    }
    if (message.company_seats_licensed !== 0) {
      obj.company_seats_licensed = Math.round(message.company_seats_licensed);
    }
    if (message.company_seats_active !== 0) {
      obj.company_seats_active = Math.round(message.company_seats_active);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgUsage>, I>>(base?: I): StcsOrgUsage {
    return StcsOrgUsage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgUsage>, I>>(object: I): StcsOrgUsage {
    const message = createBaseStcsOrgUsage();
    message.user_seats_licensed = object.user_seats_licensed ?? 0;
    message.user_seats_active = object.user_seats_active ?? 0;
    message.company_seats_licensed = object.company_seats_licensed ?? 0;
    message.company_seats_active = object.company_seats_active ?? 0;
    return message;
  },
};

function createBaseStcsOrgSubscription(): StcsOrgSubscription {
  return {
    valid_until_iso_utc: "",
    customer_external_id: "",
    subscription_external_id: "",
    usage: undefined,
    subscription_status: 0,
    ref_id_product_org_seats: "",
    ref_id_product_user_seats: "",
    ref_id_product_company_seats: "",
    subscription_cycle: 0,
  };
}

export const StcsOrgSubscription: MessageFns<StcsOrgSubscription> = {
  encode(message: StcsOrgSubscription, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.valid_until_iso_utc !== "") {
      writer.uint32(10).string(message.valid_until_iso_utc);
    }
    if (message.customer_external_id !== "") {
      writer.uint32(18).string(message.customer_external_id);
    }
    if (message.subscription_external_id !== "") {
      writer.uint32(26).string(message.subscription_external_id);
    }
    if (message.usage !== undefined) {
      StcsOrgUsage.encode(message.usage, writer.uint32(34).fork()).join();
    }
    if (message.subscription_status !== 0) {
      writer.uint32(64).int32(message.subscription_status);
    }
    if (message.ref_id_product_org_seats !== "") {
      writer.uint32(82).string(message.ref_id_product_org_seats);
    }
    if (message.ref_id_product_user_seats !== "") {
      writer.uint32(90).string(message.ref_id_product_user_seats);
    }
    if (message.ref_id_product_company_seats !== "") {
      writer.uint32(98).string(message.ref_id_product_company_seats);
    }
    if (message.subscription_cycle !== 0) {
      writer.uint32(104).int32(message.subscription_cycle);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgSubscription {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgSubscription();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.valid_until_iso_utc = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.customer_external_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.subscription_external_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.usage = StcsOrgUsage.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.subscription_status = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.ref_id_product_org_seats = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.ref_id_product_user_seats = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.ref_id_product_company_seats = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.subscription_cycle = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgSubscription {
    return {
      valid_until_iso_utc: isSet(object.valid_until_iso_utc) ? globalThis.String(object.valid_until_iso_utc) : "",
      customer_external_id: isSet(object.customer_external_id) ? globalThis.String(object.customer_external_id) : "",
      subscription_external_id: isSet(object.subscription_external_id)
        ? globalThis.String(object.subscription_external_id)
        : "",
      usage: isSet(object.usage) ? StcsOrgUsage.fromJSON(object.usage) : undefined,
      subscription_status: isSet(object.subscription_status)
        ? stcsEntityStatusEnumFromJSON(object.subscription_status)
        : 0,
      ref_id_product_org_seats: isSet(object.ref_id_product_org_seats)
        ? globalThis.String(object.ref_id_product_org_seats)
        : "",
      ref_id_product_user_seats: isSet(object.ref_id_product_user_seats)
        ? globalThis.String(object.ref_id_product_user_seats)
        : "",
      ref_id_product_company_seats: isSet(object.ref_id_product_company_seats)
        ? globalThis.String(object.ref_id_product_company_seats)
        : "",
      subscription_cycle: isSet(object.subscription_cycle)
        ? stcsSubProductCycleEnumFromJSON(object.subscription_cycle)
        : 0,
    };
  },

  toJSON(message: StcsOrgSubscription): unknown {
    const obj: any = {};
    if (message.valid_until_iso_utc !== "") {
      obj.valid_until_iso_utc = message.valid_until_iso_utc;
    }
    if (message.customer_external_id !== "") {
      obj.customer_external_id = message.customer_external_id;
    }
    if (message.subscription_external_id !== "") {
      obj.subscription_external_id = message.subscription_external_id;
    }
    if (message.usage !== undefined) {
      obj.usage = StcsOrgUsage.toJSON(message.usage);
    }
    if (message.subscription_status !== 0) {
      obj.subscription_status = stcsEntityStatusEnumToJSON(message.subscription_status);
    }
    if (message.ref_id_product_org_seats !== "") {
      obj.ref_id_product_org_seats = message.ref_id_product_org_seats;
    }
    if (message.ref_id_product_user_seats !== "") {
      obj.ref_id_product_user_seats = message.ref_id_product_user_seats;
    }
    if (message.ref_id_product_company_seats !== "") {
      obj.ref_id_product_company_seats = message.ref_id_product_company_seats;
    }
    if (message.subscription_cycle !== 0) {
      obj.subscription_cycle = stcsSubProductCycleEnumToJSON(message.subscription_cycle);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgSubscription>, I>>(base?: I): StcsOrgSubscription {
    return StcsOrgSubscription.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgSubscription>, I>>(object: I): StcsOrgSubscription {
    const message = createBaseStcsOrgSubscription();
    message.valid_until_iso_utc = object.valid_until_iso_utc ?? "";
    message.customer_external_id = object.customer_external_id ?? "";
    message.subscription_external_id = object.subscription_external_id ?? "";
    message.usage = (object.usage !== undefined && object.usage !== null)
      ? StcsOrgUsage.fromPartial(object.usage)
      : undefined;
    message.subscription_status = object.subscription_status ?? 0;
    message.ref_id_product_org_seats = object.ref_id_product_org_seats ?? "";
    message.ref_id_product_user_seats = object.ref_id_product_user_seats ?? "";
    message.ref_id_product_company_seats = object.ref_id_product_company_seats ?? "";
    message.subscription_cycle = object.subscription_cycle ?? 0;
    return message;
  },
};

function createBaseStcsOrgUserList(): StcsOrgUserList {
  return { org_user_data_map: {} };
}

export const StcsOrgUserList: MessageFns<StcsOrgUserList> = {
  encode(message: StcsOrgUserList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.org_user_data_map).forEach(([key, value]) => {
      StcsOrgUserList_OrgUserDataMapEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgUserList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgUserList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = StcsOrgUserList_OrgUserDataMapEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.org_user_data_map[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgUserList {
    return {
      org_user_data_map: isObject(object.org_user_data_map)
        ? Object.entries(object.org_user_data_map).reduce<{ [key: string]: StcsUserData }>((acc, [key, value]) => {
          acc[key] = StcsUserData.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsOrgUserList): unknown {
    const obj: any = {};
    if (message.org_user_data_map) {
      const entries = Object.entries(message.org_user_data_map);
      if (entries.length > 0) {
        obj.org_user_data_map = {};
        entries.forEach(([k, v]) => {
          obj.org_user_data_map[k] = StcsUserData.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgUserList>, I>>(base?: I): StcsOrgUserList {
    return StcsOrgUserList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgUserList>, I>>(object: I): StcsOrgUserList {
    const message = createBaseStcsOrgUserList();
    message.org_user_data_map = Object.entries(object.org_user_data_map ?? {}).reduce<{ [key: string]: StcsUserData }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsUserData.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsOrgUserList_OrgUserDataMapEntry(): StcsOrgUserList_OrgUserDataMapEntry {
  return { key: "", value: undefined };
}

export const StcsOrgUserList_OrgUserDataMapEntry: MessageFns<StcsOrgUserList_OrgUserDataMapEntry> = {
  encode(message: StcsOrgUserList_OrgUserDataMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsUserData.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgUserList_OrgUserDataMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgUserList_OrgUserDataMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsUserData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgUserList_OrgUserDataMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsUserData.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsOrgUserList_OrgUserDataMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsUserData.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgUserList_OrgUserDataMapEntry>, I>>(
    base?: I,
  ): StcsOrgUserList_OrgUserDataMapEntry {
    return StcsOrgUserList_OrgUserDataMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgUserList_OrgUserDataMapEntry>, I>>(
    object: I,
  ): StcsOrgUserList_OrgUserDataMapEntry {
    const message = createBaseStcsOrgUserList_OrgUserDataMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsUserData.fromPartial(object.value)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
